import React, { useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/uiComponents/components/ui/table";
import { invitationsListApi } from "@/modules/organizationServices";
import { toast } from "sonner";
import { AuthError } from "@/enums/errorMessages";
import { useDispatch, useSelector } from "react-redux";
import { setInvitations } from "@/store/redux/organization/memberSlice";
import { RootState } from "@/store/store";
import { Check, X } from "lucide-react";
import { DisplayInvitationStatus, getDisplayRole } from "@/utils/roleHelper";

export function SentInvitations() {
  const invitations = useSelector(
    (state: RootState) => state.member.invitations,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchInvitations = async () => {
      try {
        const response = await invitationsListApi();
        if (response.invitations != undefined) {
          dispatch(setInvitations(response.invitations));
        }
      } catch (error) {
        if (error) toast.error(AuthError.UNKNOWN_ERROR);
      }
    };

    fetchInvitations();
  }, []);

  return (
    <>
      <div className=" font-semibold text-2xl mb-5 ml-4">
        <h2>Invitations List</h2>
      </div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Sent To</TableHead>
            <TableHead>Role</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Is Used</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {invitations.map((invitation) => (
            <TableRow key={invitation.id}>
              <TableCell>{invitation.email}</TableCell>
              <TableCell className="font-medium">
                <span
                  className={`text-sm font-medium px-3 py-1 rounded-full ${getDisplayRole(invitation.role).className}`}
                >
                  {getDisplayRole(invitation.role).label}
                </span>
              </TableCell>
              <TableCell>
                {" "}
                <span
                  className={`text-sm font-medium px-3 py-1 rounded-full ${DisplayInvitationStatus(invitation.status).className}`}
                >
                  {DisplayInvitationStatus(invitation.status).label}
                </span>
              </TableCell>
              <TableCell>
                {invitation.isUsed ? (
                  <Check className="bg-green-300 rounded-md p-1" />
                ) : (
                  <X className="bg-red-400 rounded-md p-1" />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}
